<template>
    <!--  <v-overlay id="loading" :value="overlay" v-bind="options.overlayProps">-->
    <!--    <v-progress-circular v-bind="options.spinnerProps"></v-progress-circular>-->
    <!--  </v-overlay>-->
    <div class="overlay" id="loading" v-show="overlay">
        <div class="spinner">

        </div>
    </div>
</template>

<script>
    export default {
        inheritAttrs: true,
        props: {
            spinnerProps: Object,
            overlayProps: Object
        },
        data() {
            return {
                loading: false,
                overlay: false,
                defaultProps: {
                    spinnerProps: {
                        color: "primary",
                        value: 100,
                        indeterminate: true,
                        size: 80
                    },
                    overlayProps: {}
                },
                options: {
                    spinnerProps: {},
                    overlayProps: {}
                }
            };
        },
        methods: {
            show() {
                let loadingElement = document.getElementById("loading")
                if (loadingElement == null) {
                    document.getElementById("app").appendChild(this.$el);
                }
                this.loading = true;
                setTimeout(() => {
                    if (this.loading) {
                        this.overlay = true;
                    } else {
                        this.overlay = false;
                    }
                }, 100);
            },
            hide() {
                this.loading = false;
                if (this.loading) {
                    this.overlay = true;
                } else {
                    this.overlay = false;
                }
            },
            mergeProps() {
                //merge snipper props
                this.options.spinnerProps = {
                    ...this.defaultProps.spinnerProps,
                    ...this.$props.spinnerProps
                };

                //merge overlay props
                this.options.overlayProps = {
                    ...this.defaultProps.overlayProps,
                    ...this.$props.overlayProps
                };
                //console.log(this.options);
            }
        },
        beforeMount() {
            this.$nextTick(function () {
                // this does not work, don't know why. whatever, comment it out. qingshuang 2020/12/31
                // document.getElementById("app").appendChild(this.$el);
            });
        },
        mounted() {
            this.mergeProps();
        }
    };
</script>

<style scoped>
    .overlay {
        width: 100vw;
        height: 100vh;
        /*background-color: rgba(0, 0, 0, 0.3);*/
        position: fixed;
        top: 0;
        left: 0;
        z-index: 90;
    }

    .spinner {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        height: 100px;
        width: 100px;
        margin: -25px 0 0 -25px;
        border: 2px solid transparent;
        /*border-top-color: rgba(255, 255, 255, 0.99);*/
        /*box-shadow: 0 0 5px rgba(255, 255, 255, 0.9);*/
        /*border-radius: 50%;*/
        /*-webkit-animation: spin8 2s linear infinite;*/
        /*animation: spin8 2s linear infinite;*/
    }

    .spinner:before {
        content: "";
        position: absolute;
        top: 2px;
        right: 2px;
        bottom: 2px;
        left: 2px;
        border: 2px solid transparent;
        border-radius: 50%;
        border-top-color: #0171A3;
        box-shadow: 0 0 5px rgba(1, 113, 163, 0.3);
        -webkit-animation: spin8 .9s linear infinite;
        animation: spin8 .9s linear infinite;
    }

    /*.spinner:after {*/
    /*    content: "";*/
    /*    position: absolute;*/
    /*    top: 30px;*/
    /*    right: 30px;*/
    /*    bottom: 30px;*/
    /*    left: 30px;*/
    /*    border: 2px solid transparent;*/
    /*    border-radius: 50%;*/
    /*    border-top-color: #FFFFFF;*/
    /*    box-shadow: 0 0 5px rgba(255, 255, 255, 0.9);*/
    /*    -webkit-animation: spin8 1.5s linear infinite;*/
    /*    animation: spin8 1.5s linear infinite;*/
    /*}*/

    @-webkit-keyframes spin8 {
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }
    @keyframes spin8 {
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }
</style>
